import { h, Fragment } from 'preact';

const Breadcrumbs = ({...props}) => {
  const productUrl = props.product.primaryCollectionUrl 
    ? `${props.product.primaryCollectionUrl}/${props.product.title.replace(/\s+/g, '-').toLowerCase()}` 
    : `${props.product.shopUrl}/products/${props.product.handle}`;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "item": {
          "@id": props.product.shopUrl,
          "name": "Home"
        }
      },
      ...(props.product.primaryCollectionUrl ? [{
        "@type": "ListItem",
        "position": 2,
        "item": {
          "@id": props.product.primaryCollectionUrl,
          "name": props.product.primaryCollectionName
        }
      }] : []),
      {
        "@type": "ListItem",
        "position": props.product.primaryCollectionUrl ? 3 : 2,
        "item": {
          "@id": productUrl,
          "name": props.product.title
        }
      }
    ]
  };

  return (
    <div className='mb-4 lg:px-0'>
      <a
        href={props.product.shopUrl}
        className='navigation-link after:h-0'
        onFocus={()=>{window.scrollTo(0,0)}}
      >
        Home
      </a>
      {props.product.primaryCollectionUrl && 
        <>
          <span className='navigation-link after:h-0'> / </span>
          <a href={props.product.primaryCollectionUrl} 
            className='navigation-link after:h-0 capitalize'>
            {props.product.primaryCollectionName}
          </a>
        </>
      }
      <span className='navigation-link after:h-0'> / </span>
      <span className='navigation-link after:h-0 capitalize'>
        {props.product.title}
      </span>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd, null, 2) }} />
    </div>
  );
}

export default Breadcrumbs;
